module.exports = __webpack_public_path__ + "img/7.2f0871fc.jpg";